import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export const getAdMediums = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.adMediumFilterParams === undefined) {
        throw new Error('Missing required body: adMediumFilterParams');
    }
    const path = '/api/ws-broadcast/ad-mediums/filter';
    const pathInternal = '/api/ad-mediums/filter';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adMediumFilterParams !== undefined) {
        body = params.adMediumFilterParams;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdMediums.paramsOrder = [{ type: 'body', paramName: 'adMediumFilterParams' }];
export const createAdMedium = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.adMediumForm === undefined) {
        throw new Error('Missing required body: adMediumForm');
    }
    const path = '/api/ws-broadcast/ad-mediums';
    const pathInternal = '/api/ad-mediums';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adMediumForm !== undefined) {
        body = params.adMediumForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAdMedium.paramsOrder = [{ type: 'body', paramName: 'adMediumForm' }];
export const getAdMediumById = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.adMediumId === undefined) {
        throw new Error('Missing required parameter: adMediumId');
    }
    const path = '/api/ws-broadcast/ad-mediums/{adMediumId}'.replace('{adMediumId}', params.adMediumId?.toString());
    const pathInternal = '/api/ad-mediums/{adMediumId}'.replace('{adMediumId}', params.adMediumId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdMediumById.paramsOrder = [{ type: 'parameters' }];
export const updateAdMedium = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.adMediumId === undefined) {
        throw new Error('Missing required parameter: adMediumId');
    }
    if (params.adMediumForm === undefined) {
        throw new Error('Missing required body: adMediumForm');
    }
    const path = '/api/ws-broadcast/ad-mediums/{adMediumId}'.replace('{adMediumId}', params.adMediumId?.toString());
    const pathInternal = '/api/ad-mediums/{adMediumId}'.replace('{adMediumId}', params.adMediumId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adMediumForm !== undefined) {
        body = params.adMediumForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdMedium.paramsOrder = [{ type: 'body', paramName: 'adMediumForm' }, { type: 'parameters' }];
export const getAllAdPlacements = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.placementFilterParams === undefined) {
        throw new Error('Missing required body: placementFilterParams');
    }
    const path = '/api/ws-broadcast/adplacements/filter';
    const pathInternal = '/api/adplacements/filter';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.placementFilterParams !== undefined) {
        body = params.placementFilterParams;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllAdPlacements.paramsOrder = [{ type: 'body', paramName: 'placementFilterParams' }];
export const createAdPlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.adPlacement === undefined) {
        throw new Error('Missing required body: adPlacement');
    }
    const path = '/api/ws-broadcast/adplacements';
    const pathInternal = '/api/adplacements';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adPlacement !== undefined) {
        body = params.adPlacement;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAdPlacement.paramsOrder = [{ type: 'body', paramName: 'adPlacement' }];
export const getAdPlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-broadcast/adplacements/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/adplacements/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdPlacement.paramsOrder = [{ type: 'parameters' }];
export const updateAdPlacement = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.adPlacement === undefined) {
        throw new Error('Missing required body: adPlacement');
    }
    const path = '/api/ws-broadcast/adplacements/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/adplacements/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adPlacement !== undefined) {
        body = params.adPlacement;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdPlacement.paramsOrder = [{ type: 'body', paramName: 'adPlacement' }, { type: 'parameters' }];
export const getAdTypes = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.adTypeFilterParams === undefined) {
        throw new Error('Missing required body: adTypeFilterParams');
    }
    const path = '/api/ws-broadcast/ad-types/filter';
    const pathInternal = '/api/ad-types/filter';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adTypeFilterParams !== undefined) {
        body = params.adTypeFilterParams;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdTypes.paramsOrder = [{ type: 'body', paramName: 'adTypeFilterParams' }];
export const createAdType = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.adTypeForm === undefined) {
        throw new Error('Missing required body: adTypeForm');
    }
    const path = '/api/ws-broadcast/ad-types';
    const pathInternal = '/api/ad-types';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adTypeForm !== undefined) {
        body = params.adTypeForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAdType.paramsOrder = [{ type: 'body', paramName: 'adTypeForm' }];
export const getAdTypeById = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.adTypeId === undefined) {
        throw new Error('Missing required parameter: adTypeId');
    }
    const path = '/api/ws-broadcast/ad-types/{adTypeId}'.replace('{adTypeId}', params.adTypeId?.toString());
    const pathInternal = '/api/ad-types/{adTypeId}'.replace('{adTypeId}', params.adTypeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdTypeById.paramsOrder = [{ type: 'parameters' }];
export const updateAdType = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.adTypeId === undefined) {
        throw new Error('Missing required parameter: adTypeId');
    }
    if (params.adTypeForm === undefined) {
        throw new Error('Missing required body: adTypeForm');
    }
    const path = '/api/ws-broadcast/ad-types/{adTypeId}'.replace('{adTypeId}', params.adTypeId?.toString());
    const pathInternal = '/api/ad-types/{adTypeId}'.replace('{adTypeId}', params.adTypeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adTypeForm !== undefined) {
        body = params.adTypeForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdType.paramsOrder = [{ type: 'body', paramName: 'adTypeForm' }, { type: 'parameters' }];
export const getAdSpecs = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.adSpecFilterParams === undefined) {
        throw new Error('Missing required body: adSpecFilterParams');
    }
    const path = '/api/ws-broadcast/ad-specs/filter';
    const pathInternal = '/api/ad-specs/filter';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adSpecFilterParams !== undefined) {
        body = params.adSpecFilterParams;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdSpecs.paramsOrder = [{ type: 'body', paramName: 'adSpecFilterParams' }];
export const createAdSpec = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.adSpecForm === undefined) {
        throw new Error('Missing required body: adSpecForm');
    }
    const path = '/api/ws-broadcast/ad-specs';
    const pathInternal = '/api/ad-specs';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adSpecForm !== undefined) {
        body = params.adSpecForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAdSpec.paramsOrder = [{ type: 'body', paramName: 'adSpecForm' }];
export const getAdSpecById = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.adSpecId === undefined) {
        throw new Error('Missing required parameter: adSpecId');
    }
    const path = '/api/ws-broadcast/ad-specs/{adSpecId}'.replace('{adSpecId}', params.adSpecId?.toString());
    const pathInternal = '/api/ad-specs/{adSpecId}'.replace('{adSpecId}', params.adSpecId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdSpecById.paramsOrder = [{ type: 'parameters' }];
export const updateAdSpec = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.adSpecId === undefined) {
        throw new Error('Missing required parameter: adSpecId');
    }
    if (params.adSpecForm === undefined) {
        throw new Error('Missing required body: adSpecForm');
    }
    const path = '/api/ws-broadcast/ad-specs/{adSpecId}'.replace('{adSpecId}', params.adSpecId?.toString());
    const pathInternal = '/api/ad-specs/{adSpecId}'.replace('{adSpecId}', params.adSpecId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adSpecForm !== undefined) {
        body = params.adSpecForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdSpec.paramsOrder = [{ type: 'body', paramName: 'adSpecForm' }, { type: 'parameters' }];
export const checkForAdSpecCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.adSpecId === undefined) {
        throw new Error('Missing required parameter: adSpecId');
    }
    const path = '/api/ws-broadcast/ad-specs/{adSpecId}/check-for-positions'.replace('{adSpecId}', params.adSpecId?.toString());
    const pathInternal = '/api/ad-specs/{adSpecId}/check-for-positions'.replace('{adSpecId}', params.adSpecId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
checkForAdSpecCampaignPositions.paramsOrder = [{ type: 'parameters' }];
export const getAdPricesByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.adPriceIds === undefined) {
        throw new Error('Missing required body: adPriceIds');
    }
    const path = '/api/ws-broadcast/adprices/by-ids';
    const pathInternal = '/api/adprices/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adPriceIds !== undefined) {
        body = params.adPriceIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdPricesByIds.paramsOrder = [{ type: 'body', paramName: 'adPriceIds' }];
export const getAdPrices = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.adPriceFilterParams === undefined) {
        throw new Error('Missing required body: adPriceFilterParams');
    }
    const path = '/api/ws-broadcast/ad-prices/filter';
    const pathInternal = '/api/ad-prices/filter';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adPriceFilterParams !== undefined) {
        body = params.adPriceFilterParams;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdPrices.paramsOrder = [{ type: 'body', paramName: 'adPriceFilterParams' }];
export const createAdPrice = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.adPriceForm === undefined) {
        throw new Error('Missing required body: adPriceForm');
    }
    const path = '/api/ws-broadcast/ad-prices';
    const pathInternal = '/api/ad-prices';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adPriceForm !== undefined) {
        body = params.adPriceForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAdPrice.paramsOrder = [{ type: 'body', paramName: 'adPriceForm' }];
export const getAdPriceById = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.adPriceId === undefined) {
        throw new Error('Missing required parameter: adPriceId');
    }
    const path = '/api/ws-broadcast/ad-prices/{adPriceId}'.replace('{adPriceId}', params.adPriceId?.toString());
    const pathInternal = '/api/ad-prices/{adPriceId}'.replace('{adPriceId}', params.adPriceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAdPriceById.paramsOrder = [{ type: 'parameters' }];
export const updateAdPrice = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.adPriceId === undefined) {
        throw new Error('Missing required parameter: adPriceId');
    }
    if (params.adPriceForm === undefined) {
        throw new Error('Missing required body: adPriceForm');
    }
    const path = '/api/ws-broadcast/ad-prices/{adPriceId}'.replace('{adPriceId}', params.adPriceId?.toString());
    const pathInternal = '/api/ad-prices/{adPriceId}'.replace('{adPriceId}', params.adPriceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adPriceForm !== undefined) {
        body = params.adPriceForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateAdPrice.paramsOrder = [{ type: 'body', paramName: 'adPriceForm' }, { type: 'parameters' }];
export const checkForAdPriceCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.adPriceId === undefined) {
        throw new Error('Missing required parameter: adPriceId');
    }
    const path = '/api/ws-broadcast/ad-prices/{adPriceId}/check-for-positions'.replace('{adPriceId}', params.adPriceId?.toString());
    const pathInternal = '/api/ad-prices/{adPriceId}/check-for-positions'.replace('{adPriceId}', params.adPriceId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
checkForAdPriceCampaignPositions.paramsOrder = [{ type: 'parameters' }];
export const getPriceLists = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.priceListFilterParams === undefined) {
        throw new Error('Missing required body: priceListFilterParams');
    }
    const path = '/api/ws-broadcast/price-lists/filter';
    const pathInternal = '/api/price-lists/filter';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.priceListFilterParams !== undefined) {
        body = params.priceListFilterParams;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPriceLists.paramsOrder = [{ type: 'body', paramName: 'priceListFilterParams' }];
export const getCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.campaignPositionFilterParams === undefined) {
        throw new Error('Missing required body: campaignPositionFilterParams');
    }
    const path = '/api/ws-broadcast/campaign-positions/filter';
    const pathInternal = '/api/campaign-positions/filter';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionFilterParams !== undefined) {
        body = params.campaignPositionFilterParams;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'campaignPositionFilterParams' }];
export const createOrUpdateCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.campaignPositionType === undefined) {
        throw new Error('Missing required parameter: campaignPositionType');
    }
    const path = '/api/ws-broadcast/campaign-positions';
    const pathInternal = '/api/campaign-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionForms !== undefined) {
        body = params.campaignPositionForms;
    }
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    if (params.campaignPositionType !== undefined) {
        urlParams.append('campaignPositionType', params.campaignPositionType.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
createOrUpdateCampaignPositions.paramsOrder = [
    { type: 'body', paramName: 'campaignPositionForms' },
    { type: 'parameters' },
];
export const getCampaignPositionById = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-broadcast/campaign-positions/{campaignPositionId}'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/campaign-positions/{campaignPositionId}'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionById.paramsOrder = [{ type: 'parameters' }];
export const deleteCampaignPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    const path = '/api/ws-broadcast/campaign-positions/{campaignPositionId}'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    const pathInternal = '/api/campaign-positions/{campaignPositionId}'.replace('{campaignPositionId}', params.campaignPositionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteCampaignPosition.paramsOrder = [{ type: 'parameters' }];
export const updateDiscounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.discountForm === undefined) {
        throw new Error('Missing required body: discountForm');
    }
    const path = '/api/ws-broadcast/campaign-positions/update-discounts';
    const pathInternal = '/api/campaign-positions/update-discounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    if (params.discountForm !== undefined) {
        body = params.discountForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateDiscounts.paramsOrder = [{ type: 'body', paramName: 'discountForm' }, { type: 'parameters' }];
export const getReportingCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    if (params.campaignPositionType === undefined) {
        throw new Error('Missing required parameter: campaignPositionType');
    }
    const path = '/api/ws-broadcast/reporting/campaign-positions';
    const pathInternal = '/api/reporting/campaign-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    if (params.campaignPositionType !== undefined) {
        urlParams.append('campaignPositionType', params.campaignPositionType.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingCampaignPositions.paramsOrder = [{ type: 'parameters' }];
export const extractCampaignPositionsToNewCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.campaignPositionIds === undefined) {
        throw new Error('Missing required body: campaignPositionIds');
    }
    const path = '/api/ws-broadcast/campaign-positions/extract-new-campaign';
    const pathInternal = '/api/campaign-positions/extract-new-campaign';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionIds !== undefined) {
        body = params.campaignPositionIds;
    }
    const headers = {};
    headers['Accept'] = 'text/plain';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'text',
        requestType: 'json',
    });
};
extractCampaignPositionsToNewCampaign.paramsOrder = [{ type: 'body', paramName: 'campaignPositionIds' }];
export const getBookingAdSpecsWithCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.filter === undefined) {
        throw new Error('Missing required body: filter');
    }
    const path = '/api/ws-broadcast/booking/ad-specs-with-campaign-positions';
    const pathInternal = '/api/booking/ad-specs-with-campaign-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        body = params.filter;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBookingAdSpecsWithCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'filter' }];
export const getBatchCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.period === undefined) {
        throw new Error('Missing required parameter: period');
    }
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-broadcast/batch/campaign-positions';
    const pathInternal = '/api/batch/campaign-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.period !== undefined) {
        urlParams.append('period', params.period.toString());
    }
    if (params.type !== undefined) {
        urlParams.append('type', params.type.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchCampaignPositions.paramsOrder = [{ type: 'parameters' }];
export const getBatchAdMediums = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.period === undefined) {
        throw new Error('Missing required parameter: period');
    }
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-broadcast/batch/admediums';
    const pathInternal = '/api/batch/admediums';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.period !== undefined) {
        urlParams.append('period', params.period.toString());
    }
    if (params.type !== undefined) {
        urlParams.append('type', params.type.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchAdMediums.paramsOrder = [{ type: 'parameters' }];
export const getBatchAdPrices = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-broadcast/batch/ad-prices';
    const pathInternal = '/api/batch/ad-prices';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.period !== undefined) {
        urlParams.append('period', params.period.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchAdPrices.paramsOrder = [{ type: 'parameters' }];
export const getBatchPlacements = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.period === undefined) {
        throw new Error('Missing required parameter: period');
    }
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-broadcast/batch/placements';
    const pathInternal = '/api/batch/placements';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.period !== undefined) {
        urlParams.append('period', params.period.toString());
    }
    if (params.type !== undefined) {
        urlParams.append('type', params.type.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchPlacements.paramsOrder = [{ type: 'parameters' }];
export const cloneCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (params.originalCampaignId === undefined) {
        throw new Error('Missing required parameter: originalCampaignId');
    }
    const path = '/api/ws-broadcast/campaign-positions/clone-by-campaign';
    const pathInternal = '/api/campaign-positions/clone-by-campaign';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    if (params.originalCampaignId !== undefined) {
        urlParams.append('originalCampaignId', params.originalCampaignId.toString());
    }
    if (params.shouldFetchActualCommission !== undefined) {
        urlParams.append('shouldFetchActualCommission', params.shouldFetchActualCommission.toString());
    }
    if (params.manualStartDate !== undefined) {
        urlParams.append('manualStartDate', params.manualStartDate.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
cloneCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const findInactiveProductPositionsOnClone = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-broadcast/campaigns/{campaignId}/campaign-positions/inactive-product'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/campaign-positions/inactive-product'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'json',
        requestType: 'json',
    });
};
findInactiveProductPositionsOnClone.paramsOrder = [{ type: 'parameters' }];
export const replaceAccountId = async ({ params, onUploadProgress, signal, baseURL, isInternal, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.newAccountId === undefined) {
        throw new Error('Missing required parameter: newAccountId');
    }
    const path = '/api/ws-broadcast/accounts/replace-account-id';
    const pathInternal = '/api/accounts/replace-account-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.newAccountId !== undefined) {
        urlParams.append('newAccountId', params.newAccountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers,
        responseTypes: 'void',
        requestType: 'json',
    });
};
replaceAccountId.paramsOrder = [{ type: 'parameters' }];
export * from './types';
export * from './constants';
